var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectTitleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28174 20.1549V23.3419C1.28174 23.8942 1.72945 24.3419 2.28174 24.3419H5.53981C5.80267 24.3419 6.05496 24.2384 6.24209 24.0538L19.9002 10.5802C20.2972 10.1886 20.2972 9.54802 19.9002 9.15643L16.6558 5.9559C16.2664 5.57176 15.6407 5.57176 15.2513 5.9559L1.57946 19.443C1.38897 19.6309 1.28174 19.8873 1.28174 20.1549Z",
    fill: "#93979F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9196 0.69279L18.009 2.57754C17.612 2.96914 17.612 3.60975 18.009 4.00134L21.9203 7.85976C22.3097 8.24389 22.9354 8.24389 23.3248 7.85976L25.2354 5.97501C25.6324 5.58341 25.6324 4.9428 25.2354 4.55121L21.3241 0.69279C20.9347 0.308657 20.309 0.308657 19.9196 0.69279Z",
    fill: "#93979F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00339 4.78379L4.81624 2.00895C5.20563 1.62482 5.8314 1.62482 6.2208 2.00895L24.5685 20.1087C24.9655 20.5003 24.9655 21.1409 24.5685 21.5325L21.7557 24.3074C21.3663 24.6915 20.7405 24.6915 20.3511 24.3074L2.00339 6.20759C1.60643 5.81599 1.60643 5.17538 2.00339 4.78379Z",
    stroke: "#93979F",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95148 5.9209L8.61768 7.23668",
    stroke: "#93979F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9554 16.4475L18.6216 17.7633",
    stroke: "#93979F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTitleIcon);
export default __webpack_public_path__ + "static/media/ProjectTitleIcon.436dabd1.svg";
export { ForwardRef as ReactComponent };